import React from "react";

export type ChatbotData = {
  chatbot_icon: string;
  chatbot_background_image: string;
  chatbot_title: string;
  chatbot_title_color: string;
  chatbot_plan: string;
  chatbot_flag: string;
  chatbot_S3_URL: string;
  set_font?: string; // Webフォント設定: "noto-sans-jp" | "mplus-rounded" | "kosugi-maru" | "sawarabi-gothic"
  homepage_url?: string;
  ai_name?: string;
  chatbot_icon_width?: number;
  chatbot_icon_height?: number;
  chatbot_icon_radius?: number;
  chatbot_icon_path?: string;
  chatbot_icon_position_x?: number;
  chatbot_icon_position_y?: number;
  subscription_info?: {
    has_subscription: boolean;
    plans: Array<{
      plan_type: string;
      plan_id: string;
      plan_name: string;
      price: number;
      billing_type: string;
      limit_count: number;
      plan_number: number | null;
      status: string;
    }>;
    basic_plan?: {
      plan_type: string;
      plan_id: string;
      plan_name: string;
      price: number;
      billing_type: string;
      limit_count: number;
      plan_number: number | null;
      status: string;
    } | null;
  };
};

// API実際の返却データ構造
export type Screen2DataItem = {
  sort_num: number;
  title: string;
  type: string;
  link: string;
  image_path: string;
  file_path: string;
  memo?: string;
};

export type Screen2Data = Array<Screen2DataItem> | {
  title?: string;
  cta_data?: Array<{
    cta_sort: string;
    title: string;
    type: string;
    form_title: string;
    form: any[];
    download_link: string;
    image: string;
  }>;
  banner_data?: Array<{
    banner_sort: string;
    title: string;
    type: string;
    link: string;
    image: string;
  }>;
};

export type BottomViewDataItem = {
  data_sort: string | number;
  title: string;
  type: string | number;
  dl_type?: string | number; // ダウンロードフォームタイプ
  form_text?: string;
  form_title?: string;
  link?: string | null;
  image?: string;
  download_files?: string[]; // ダウンロードファイルリスト
  page_details?: Array<{
    title: string;
    type: string;
    form_text?: string;
    placeholder?: string;
    required?: number | boolean;
  }>;
  // 旧構造（互換性のため残す）
  page?: Array<{
    title: string;
    type: string;
    form_text?: string;
    placeholder?: string;
    required?: number | boolean;
  }>;
  form_01?: {
    form_name: string;
    input: Array<{
      title: string;
      type: string;
      placeholder: string;
      required: boolean;
    }>;
  };
};

export type BottomViewData = {
  title: string;
  data: Array<BottomViewDataItem>;
} | Array<{
  title: string;
  data: Array<BottomViewDataItem>;
}>;

export type CTAData = {
  title?: string;
  description?: string;
  cta_data: Array<{
    cta_sort: number | string;
    title: string;
    type: number | string;
    form_title: string;
    form: any[];
    download_link: string[] | string;
    image: string;
    dl_type?: number | string;
    data_sort?: number | string;
    url?: string;
    cta_link?: string;
    link?: string;
  }>;
};

export type InitializeResponse = {
  model: string;
  answer: string[];
  screen2_data: Screen2Data;
  screen2_data_count?: number;
  screen2_header_text?: string | null;
  cta_data?: CTAData;
  chat_display_cta_data?: CTAData;
  chatbot_data: ChatbotData;
  bottom_view_data: BottomViewData;
  bottom_view_items_count?: number;
  session_id?: string;
  // チャットボット停止・制限超過時に返却されるフィールド
  is_bot_active?: boolean;
  // サービス解約済み時に返却されるフィールド
  is_service_cancelled?: boolean;
  message?: string;
};

type ChatbotConfigContextType = {
  chatbotData: ChatbotData | null;
  screen2Data: Screen2Data | null;
  screen2DataCount: number;
  screen2HeaderText: string;
  ctaData: CTAData | null;
  chatDisplayCtaData: CTAData | null;
  bottomViewData: BottomViewData | null;
  bottomViewItemsCount: number;
  setChatbotConfig: (config: Partial<InitializeResponse>) => void;
  isLoaded: boolean;
  isBotBlocked: boolean;
};

export const ChatbotConfigContext = React.createContext<
  ChatbotConfigContextType | undefined
>(undefined);
